import type { ServiceHost } from '@core';
import { authService } from './auth-service';
import { databaseService } from './database-service';
import { functionsService } from './functions-service';

export const serviceHost: ServiceHost = {
  getAuthenticationService() {
    return authService;
  },
  getDatabaseService() {
    return databaseService;
  },
  getFunctionsService() {
    return functionsService;
  },
};
